function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M357.027 377.397L355.452 379.571C341.833 398.098 328.859 414.884 318.28 429.141C286.331 472.15 178.62 585.706 63.6472 519.633L53.6119 512.614C45.7067 506.018 38.4696 498.659 32.0052 490.645C-36.785 405.006 24.1281 283.479 51.17 242.401C60.9218 227.576 72.2332 209.624 84.9704 190.475C89.4367 183.74 94.092 176.864 98.9127 169.916C121.756 136.974 148.396 102.544 178.187 75.431C222.299 35.2581 238.344 12.9188 264.976 4.30132C271.372 2.28719 277.981 1.02622 284.669 0.543973C325.291 -2.77226 387.236 46.1126 387.236 46.1126C387.236 46.1126 454.451 87.4986 465.219 126.789C475.986 166.08 459.043 185.008 431.45 252.523C413.38 296.799 384.069 340.454 357.027 377.397Z",
  fill: "#243258"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M357.028 377.397L355.452 379.571L84.9707 190.475C89.437 183.74 94.0923 176.864 98.9131 169.916C121.756 136.974 148.397 102.544 178.188 75.431C222.299 35.2581 238.344 12.9188 264.977 4.30132C271.372 2.28719 277.981 1.02622 284.669 0.543973C325.291 -2.77226 387.236 46.1126 387.236 46.1126C387.236 46.1126 454.451 87.4986 465.219 126.789C475.987 166.08 459.043 185.008 431.45 252.523C413.38 296.799 384.07 340.454 357.028 377.397Z",
  fill: "url(#mouse_paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M362.683 88.9937L355.388 83.8934C348.864 79.3316 339.876 80.9228 335.315 87.4474L281.404 164.554C276.843 171.078 278.434 180.065 284.958 184.627L292.253 189.728C298.778 194.289 307.765 192.698 312.327 186.174L366.237 109.067C370.799 102.543 369.208 93.5555 362.683 88.9937Z",
  fill: "#1A1542"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M389.919 47.6037L384.903 44.0967L239.078 252.666L244.094 256.173L389.919 47.6037Z",
  fill: "#1A1542"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M359.73 108.152L309.238 180.369C307.682 182.59 305.31 184.104 302.64 184.578C299.97 185.052 297.221 184.447 294.996 182.897L292.791 181.322L290.49 179.747C289.381 178.98 288.433 178.003 287.703 176.869C286.972 175.736 286.472 174.47 286.232 173.143C285.992 171.816 286.016 170.454 286.304 169.137C286.591 167.82 287.136 166.572 287.907 165.465L338.399 93.2488C339.169 92.1434 340.15 91.201 341.285 90.4754C342.42 89.7499 343.688 89.2555 345.014 89.0206C346.341 88.7857 347.701 88.8149 349.016 89.1066C350.332 89.3982 351.577 89.9466 352.68 90.7202L354.98 92.2956L357.185 93.8711C358.292 94.6402 359.236 95.6202 359.963 96.7549C360.69 97.8896 361.186 99.1567 361.422 100.483C361.659 101.81 361.631 103.17 361.34 104.486C361.05 105.802 360.502 107.048 359.73 108.152Z",
  fill: "#2C4A83"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M357.028 377.397C342.849 396.782 329.261 414.325 318.265 429.141C286.331 472.15 178.621 585.705 63.6475 519.633L53.6121 512.614C45.7069 506.017 38.4698 498.659 32.0054 490.645C-36.7847 405.006 24.1284 283.479 51.1703 242.4C64.3485 222.353 80.3783 196.627 98.913 169.932C148.2 177.446 202.102 196.131 255.887 234.003C322.802 281.132 349.726 332.002 357.028 377.397Z",
  fill: "url(#mouse_paint1_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0054 490.645C-36.7847 405.006 24.1284 283.479 51.1703 242.4C80.6067 197.635 124.246 124.536 178.187 75.4072C222.299 35.2343 238.344 12.8951 264.977 4.27759C262.086 31.477 249.876 69.657 210.846 108.254C146.664 171.759 4.50669 298.288 32.0054 490.645Z",
  fill: "url(#mouse_paint2_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M91.6895 532.378C195.745 567.58 288.938 468.629 318.265 429.141C350.206 386.125 403.88 320.037 431.473 252.523C454.065 197.265 469.535 174.54 468.495 146.584C443.943 158.636 412.309 183.205 389.441 233.121C351.821 315.2 281.794 492.158 91.6895 532.378Z",
  fill: "url(#mouse_paint3_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M354.995 92.3272L292.767 181.338L290.467 179.762C289.357 178.994 288.409 178.014 287.679 176.879C286.949 175.743 286.451 174.475 286.213 173.146C285.975 171.818 286.002 170.455 286.293 169.137C286.584 167.819 287.132 166.571 287.907 165.465L338.398 93.2488C339.169 92.1434 340.15 91.201 341.285 90.4754C342.42 89.7499 343.687 89.2555 345.014 89.0206C346.341 88.7857 347.701 88.8149 349.016 89.1066C350.331 89.3982 351.576 89.9466 352.679 90.7202L354.995 92.3272Z",
  fill: "#5580BC"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mouse_paint0_linear",
  x1: 393.401,
  y1: 42.4066,
  x2: 230.635,
  y2: 271.862,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5F7DB3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#214480"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#1A1542"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mouse_paint1_linear",
  x1: 166.056,
  y1: 182.635,
  x2: 187.738,
  y2: 511.899,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#214685"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#1A1542"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mouse_paint2_linear",
  x1: 44.3045,
  y1: 175.822,
  x2: 150.048,
  y2: 249.327,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#748FC2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#5877AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#305490"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#214685"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mouse_paint3_linear",
  x1: 187.285,
  y1: 504.013,
  x2: 415.751,
  y2: 203.945,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#1C2254"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#1A1542"
})));

function SvgMouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 469 540",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.a324062c.svg";
export { ForwardRef as ReactComponent };